import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import ResponsiveImage from "../../ResponsiveImage";

import styles from "./Step.module.css";

interface Props {
    index: number | "preface";
    children: h.JSX.Element | h.JSX.Element[];
    prefaceAsset?: string;
}

interface SeparatorProps {
    description: string;
}

export default function Step({
    index,
    children,
    prefaceAsset
}: Props) {
    return (
        <div class={styles.step}>
            {index === "preface"
                ? (
                    <div class={classname(styles.circle, styles.preface)}>
                        <ResponsiveImage asset={prefaceAsset}/>
                    </div>
                )
                : <div class={classname(styles.circle, "caption-2 semibold")}>{index}</div>
            }
            <div class={styles.content}>
                {children}
            </div>
        </div>
    );
}

export function StepSeparator({ description }: SeparatorProps) {
    return (
        <div class={styles.stepSeparator}>
            <div class={styles.line}/>
            <div class={styles.description}>{description}</div>
            <div class={styles.line}/>
        </div>
    );
}
